import React from 'react';
import { ToastType } from '@alefeducation/ui-elements-library-core';
import { injectAutoHideToastOfType } from '../../utils/Toast';
import {
  DUPLICATE_CUSTOM_ROLE_MESSAGE,
  ROLE_SUCCESSFULLY_CREATED,
  ROLE_SUCCESSFULLY_DELETED,
  ROLE_SUCCESSFULLY_UPDATED,
  SOMETHING_WENT_WRONG_MESSAGE,
  CUSTOM_ROLES_EXPORT_SUCCESS,
  CUSTOM_ROLES_EXPORT_FAILED,
  CUSTOM_ROLES_IMPORT_SUCCESS,
  CUSTOM_ROLES_IMPORT_FAILED,
} from '../../utils/constants';

export const TOAST_RNP_ID = 'toast-roles-and-permission-page';
export const RNPToastComponent = () => <div id={TOAST_RNP_ID} />;

const error = () => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    SOMETHING_WENT_WRONG_MESSAGE,
    ToastType.ERROR,
  );
};

const conflictError = () => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    DUPLICATE_CUSTOM_ROLE_MESSAGE,
    ToastType.ERROR,
  );
};

const createNewRoleSuccess = ({ roleName }: { roleName: string }) => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    ROLE_SUCCESSFULLY_CREATED.replace(':roleName', roleName),
    // `"${roleName}" was successfully created.`,
    ToastType.SUCCESS,
  );
};

const updateCustomRoleSuccess = ({ roleName }: { roleName: string }) => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    ROLE_SUCCESSFULLY_UPDATED.replace(':roleName', roleName),
    ToastType.SUCCESS,
  );
};

const deleteCustomRoleSuccess = ({ roleName }: { roleName: string }) => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    ROLE_SUCCESSFULLY_DELETED.replace(':roleName', roleName),
    ToastType.SUCCESS,
  );
};

const exportCustomRolesSuccess = () => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    CUSTOM_ROLES_EXPORT_SUCCESS,
    ToastType.SUCCESS,
  );
};

const exportCustomRolesError = () => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    CUSTOM_ROLES_EXPORT_FAILED,
    ToastType.ERROR,
  );
};

const importCustomRolesSuccess = ({
  created,
  updated,
  failed,
}: {
  created: number;
  updated: number;
  failed: number;
}) => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    CUSTOM_ROLES_IMPORT_SUCCESS.replace(':created', String(created))
      .replace(':updated', String(updated))
      .replace(':failed', String(failed)),
    failed > 0 && created + updated === 0 ? ToastType.ERROR : ToastType.SUCCESS,
  );
};

const importCustomRolesSummary = (summary: {
  created: number;
  updated: number;
  failed: number;
}) => {
  importCustomRolesSuccess(summary);
};

const importCustomRolesError = (message?: string) => {
  injectAutoHideToastOfType(
    TOAST_RNP_ID,
    message || CUSTOM_ROLES_IMPORT_FAILED,
    ToastType.ERROR,
  );
};

export const RNPToastHelper = {
  createNewRoleSuccess,
  updateCustomRoleSuccess,
  error,
  conflictError,
  deleteCustomRoleSuccess,
  exportCustomRolesSuccess,
  exportCustomRolesError,
  importCustomRolesSuccess,
  importCustomRolesSummary,
  importCustomRolesError,
};
